
export type GetAdminAccountPaymentSummariesParams = {
userIds: string[];
};
